import React, { useEffect, useState, useRef } from "react";

import { useNavigate, Link, useParams } from 'react-router-dom';
import { collection, query, where, getDocs, writeBatch } from "firebase/firestore";
import { Accordion, Button, Table, Container, Modal, Form } from "react-bootstrap";
import db from "./Firebase"; // your initialized Firestore
import moment from "moment";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const WorkshopRegistrations = () => {
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(true);


    // useEffect(() => {
    //     const load = async () => {
    //         setLoading(true);
    //         try {
    //             const sinceDate = moment("2025-01-27T00:00:00+05:30").toDate();
    //             const now = new Date();

    //             const snapshot = await db
    //                 .collection("workshop_registration")
    //                 .where("created_date", ">=", sinceDate)
    //                 .where("created_date", "<=", now)
    //                 .orderBy("created_date", "asc")
    //                 .get();

    //             const data = snapshot.docs.map(doc => ({
    //                 id: doc.id,
    //                 ...doc.data(),
    //             }));

    //             // Format each record
    //             const formatted = data.map((it, idx) => ({
    //                 index: idx + 1,
    //                 fullName: it.full_name || "",
    //                 phone: it.phone || "",
    //                 workshop: it.workshop_event_name || "",
    //                 createdDate: it.created_date.toDate(),
    //             }));

    //             setRows(formatted);
    //         } catch (err) {
    //             console.error("Error fetching registrations:", err);
    //         }
    //         setLoading(false);
    //     };
    //     load();
    // }, []);

    useEffect(() => {
        const load = async () => {
            setLoading(true);
            try {
                const sinceDate = moment("2025-01-27T00:00:00+05:30").toDate();
                const now = new Date();

                const snapshot = await db
                    .collection("workshop_registration")
                    .where("created_date", ">=", sinceDate)
                    .where("created_date", "<=", now)
                    .orderBy("created_date", "asc")
                    .get();

                const data = snapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data(),
                }));

                // Remove duplicates based on (phone + workshop)
                const uniqueMap = new Map();
                data.forEach((item) => {
                    const key = `${item.phone}_${item.workshop_event_name}`;
                    if (item.phone && item.workshop_event_name && !uniqueMap.has(key)) {
                        uniqueMap.set(key, item);
                    }
                });

                const uniqueData = Array.from(uniqueMap.values());

                // Format each record
                const formatted = uniqueData.map((it, idx) => ({
                    index: idx + 1,
                    fullName: it.full_name || "",
                    phone: it.phone || "",
                    workshop: it.workshop_event_name || "",
                    createdDate: it.created_date.toDate(),
                }));

                setRows(formatted);
            } catch (err) {
                console.error("Error fetching registrations:", err);
            }
            setLoading(false);
        };
        load();
    }, []);


    const handleExport = () => {
        const exportData = rows.map(r => ({
            "Sr. No.": r.index,
            "Full Name": r.fullName,
            "Phone": r.phone,
            "Workshop/Event": r.workshop,
            "Registered On": moment(r.createdDate).format("YYYY-MM-DD HH:mm")
        }));
        const ws = XLSX.utils.json_to_sheet(exportData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Registrations");
        const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        saveAs(new Blob([wbout], { type: "application/octet-stream" }), "registrations.xlsx");
    };



    // const fixWorkshopNames = async () => {
    //     try {
    //         const batch = writeBatch(db);

    //         // 1. Get all workshop_registration with full_name === "null"
    //         const workshopSnap = await getDocs(
    //             query(collection(db, "workshop_registration"), where("full_name", "==", "null"))
    //         );

    //         const workshopDocs = workshopSnap.docs;

    //         console.log(`Found ${workshopDocs.length} records with null full_name`);

    //         for (let doc of workshopDocs) {
    //             const workshopData = doc.data();
    //             const phone = workshopData.phone;

    //             // 2. Search in personal_details by phone
    //             const personSnap = await getDocs(
    //                 query(collection(db, "personal_details"), where("phone_no", "==", phone))
    //             );

    //             if (!personSnap.empty) {
    //                 const personalData = personSnap.docs[0].data();
    //                 const correctName = personalData.full_name;

    //                 if (correctName) {
    //                     const docRef = doc.ref;
    //                     batch.update(docRef, { full_name: correctName });
    //                     console.log(`Updating ${phone} with name: ${correctName}`);
    //                 }
    //             } else {
    //                 console.warn(`No personal_details found for phone: ${phone}`);
    //             }
    //         }

    //         // 3. Commit all updates
    //         await batch.commit();
    //         console.log("All matching workshop_registration names updated successfully.");

    //     } catch (err) {
    //         console.error("Error updating workshop_registration full names:", err);
    //     }
    // };


    const fixPhoneNumbers = async () => {
        try {
            const batch = writeBatch(db);

            // 1. Get all workshop_registration where phone is "null" or missing
            const workshopSnap = await getDocs(
                query(collection(db, "workshop_registration"), where("phone", "==", "null"))
            );

            const workshopDocs = workshopSnap.docs;
            console.log(`Found ${workshopDocs.length} records with null phone`);

            for (let doc of workshopDocs) {
                const workshopData = doc.data();
                const fullName = workshopData.full_name;

                // Skip if fullName is not available
                if (!fullName || fullName === "null") {
                    console.warn(`Skipping record with missing name: ${doc.id}`);
                    continue;
                }

                // 2. Search in personal_details by full_name
                const personSnap = await getDocs(
                    query(collection(db, "personal_details"), where("full_name", "==", fullName))
                );

                if (!personSnap.empty) {
                    const personalData = personSnap.docs[0].data();
                    const correctPhone = personalData.phone_no;

                    if (correctPhone && correctPhone !== "null") {
                        batch.update(doc.ref, { phone: correctPhone });
                        console.log(`✅ Updated ${fullName} with phone: ${correctPhone}`);
                    } else {
                        console.warn(`⚠️ No phone found in personal_details for ${fullName}`);
                    }
                } else {
                    console.warn(`⚠️ No personal_details found for ${fullName}`);
                }
            }

            // 3. Commit all updates
            await batch.commit();
            console.log("✅ All missing phone numbers updated successfully.");

        } catch (err) {
            console.error("❌ Error fixing phone numbers:", err);
        }
    };




    return (
        <>
            <div className="p-2" style={{ paddingBottom: "5px", display: "flex", justifyContent: "space-between" }}>
                <Link to="/">
                    <img src="/images/menubutton.png" className="menu-toggle" alt="Menu" style={{ height: "2rem" }} />
                </Link>
            </div>
            <div className="mb-3 d-flex align-items-center gap-3">


            </div>
            <div className="p-3">
                <div className="card-header pb-0 px-3" style={{ display: "flex" }}>
                    <h2>Workshop Registrations (Since Jan 1st, 2025)</h2>

                    {/* <button onClick={() => fixPhoneNumbers()}>Click Update</button> */}


                    <div className="ml-4">
                        <Button variant="success" onClick={handleExport}>
                            Download Excel
                        </Button>
                    </div>
                </div>
                <div className="table-responsive fix-width scroll-inner">
                    <table className="table table-bordered table-hover">
                        <thead className="thead-dark" style={{ position: "sticky", top: "0" }}>
                            <tr>
                                <th>#</th>
                                <th>Full Name</th>
                                <th>Phone</th>
                                <th>Workshop/Event</th>
                                <th>Created Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            {rows.map(r => (
                                <tr key={r.id}>
                                    <td>{r.index}</td>
                                    <td>{r.fullName}</td>
                                    <td>{r.phone}</td>
                                    <td>{r.workshop}</td>
                                    <td>
                                        {moment(r.createdDate).format("YYYY-MM-DD HH:mm")}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>


            </div>
        </>
    );
};

export default WorkshopRegistrations;